import React, { useEffect, useState } from "react";
import { PartnerContext } from "./UserContext";
import { useHistory } from "react-router-dom";

export default function UserContextProvider(props) {
  const [userData, setUserData] = useState({});
  const value = { ...userData, setUserData };

  // const { go } = useHistory();

  useEffect(() => {
    getUserData();
  }, [props]);

  async function getUserData() {
    const nUserData = sessionStorage.getItem("data");
    const nLogeedInNew = sessionStorage.getItem("?login1");
    if (!nLogeedInNew) {
      sessionStorage.clear();
      window.location.href = "#/login";
      return;
    }
    // if (!nUserData) {
    //   // ppush("#/login");
    // }
    userData && setUserData(JSON.parse(nUserData));
  }

  return (
    <PartnerContext.Provider value={value}>
      {props.children}
    </PartnerContext.Provider>
  );
}
